import './App.css';
import AppRoutes from './AppRoutes';
import Layout from './Layout';

function App() {
  return (
    <Layout>
      <AppRoutes />
    </Layout>
  );
}

export default App;
